document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.jQuery === 'undefined') return;

  var $ = window.jQuery;

  var selectors = {
    prePleated: '.pre-pleated_wc',
    blouse: '.blouse_stitching_wc',
    fallHemming: '.fall_hemming_wc, .cape_wc',
    addToCart: '.multi-prod-cart, .multi-prod-cart-addon, .add_to_cart_product_form',
    measurements: '#prepleated-waist, #prepleated-hip, #prepleated-length',
    unitToggle: '.preplated_unit_toggle .toggle-switch'
  };

  function isActive($element) {
    return $element.hasClass('active-wc') || $element.hasClass('active');
  }

  function togglePrePleatedFields() {
    var $prePleated = $(selectors.prePleated);

    if (isActive($prePleated)) {
      $('.pre-pleated-addon-sec').slideDown(200);
      return;
    }

    $('.pre-pleated-addon-sec').slideUp(200);

    $('#prepleated-waist, #prepleated-hip, #prepleated-length').val('');
    $('#customisation-waist-hidden, #customisation-hip-hidden, #customisation-length-hidden').val('');
  }

  function updateBlouseStitchingValue() {
    var isBlouseSelected = isActive($(selectors.blouse));

    $('.product-form input[name="properties[Blouse Stitching]"]').val(isBlouseSelected ? 'Yes' : 'No');
  }

  function updateFallHemmingValue() {
    var isFallHemmingSelected = false;

    $(selectors.fallHemming).each(function () {
      var $addon = $(this);
      var dataText = ($addon.find('h3').attr('data-text') || '').toLowerCase();
      var visibleText = ($addon.find('.addon-text-left').text() || '').toLowerCase();
      var addonText = dataText + ' ' + visibleText;

      var isFallHemmingOption = addonText.includes('fall') || addonText.includes('hemming');

      if (isFallHemmingOption && isActive($addon)) {
        isFallHemmingSelected = true;
      }
    });

    $('.product-form input[name="properties[Fall & Hemming]"]').val(isFallHemmingSelected ? 'Yes' : 'No');
  }

  function updatePrePleatedMeasurements() {
    var unit = $(selectors.unitToggle).hasClass('active') ? 'Cms' : 'Inch';

    var waistSize = $('#prepleated-waist').val();
    var hipSize = $('#prepleated-hip').val();
    var lengthSize = $('#prepleated-length').val();

    $('#customisation-waist-hidden').val(waistSize ? waistSize + ' ' + unit : '');
    $('#customisation-hip-hidden').val(hipSize ? hipSize + ' ' + unit : '');
    $('#customisation-length-hidden').val(lengthSize ? lengthSize + ' ' + unit : '');
  }

  function updateAllAddonProperties() {
    updateBlouseStitchingValue();
    updateFallHemmingValue();
    updatePrePleatedMeasurements();
  }

  $(document).on('click', selectors.prePleated, function () {
    setTimeout(togglePrePleatedFields, 50);
  });

  $(document).on('click', selectors.blouse, function () {
    setTimeout(updateBlouseStitchingValue, 100);
  });

  $(document).on('click', selectors.fallHemming, function () {
    setTimeout(updateFallHemmingValue, 100);
  });

  $(document).on('click', selectors.addToCart, function () {
    updateAllAddonProperties();
  });

  $(document).on('change', '.size_input_sec input[type="radio"]', function () {
    $('.size_input_sec label').removeClass('checked');

    if ($(this).is(':checked')) {
      $(this).parent('label').addClass('checked');
    }
  });

  $(document).on('input', selectors.measurements, function () {
    updatePrePleatedMeasurements();
  });

  $(document).on('click', selectors.unitToggle, function () {
    $(this).toggleClass('active');
    updatePrePleatedMeasurements();
  });

  togglePrePleatedFields();
  updateAllAddonProperties();
});